// Initialize all lottery webform paragraphs
const initializeLotteryWebforms = () => {
  // Find all lottery webform paragraphs
  const webformParagraphs = document.querySelectorAll(
    '.paragraph--lottery-webform',
  );

  if (!webformParagraphs.length) {
    return;
  }

  webformParagraphs.forEach((section) => {
    const handleSelectCombination = () => {
      // Get all selects within this specific section
      const selects = section.querySelectorAll('.lottery-webform__select');
      const hiddenInput = section.querySelector(
        'input[name="questions_and_answers"]',
      );

      if (!hiddenInput) {
        return;
      }

      // Create a combined string from all selects and their questions
      const combinedValue = Array.from(selects).reduce((acc, select) => {
        // Find the question text by looking for lottery-webform__select-question
        const findQuestion = (element) => {
          // First, find the description div that contains the question
          const descriptionId = element.getAttribute('aria-describedby');
          if (!descriptionId) return null;

          const descriptionDiv = document.getElementById(descriptionId);

          if (!descriptionDiv) return null;

          // Find the question element within the description div
          const questionElement = descriptionDiv.querySelector(
            '.lottery-webform__select-question',
          );
          const labelElement = descriptionDiv.querySelector(
            '.lottery-webform__select-label',
          );

          return (
            questionElement?.textContent?.trim() ||
            labelElement?.textContent?.trim()
          );
        };

        const question = findQuestion(select);
        const selectedValue = select.value;

        // Only add to accumulator if both question and value exist and value is not the default
        if (question && selectedValue) {
          const separator = acc ? ', ' : '';
          return `${acc}${separator}${question}: ${selectedValue}`;
        }
        return acc;
      }, '');

      // Update hidden input value for this section
      hiddenInput.value = combinedValue;
    };

    // Add event listeners to all relevant selects within this section
    section.querySelectorAll('.lottery-webform__select').forEach((select) => {
      select.addEventListener('change', handleSelectCombination);
    });

    // Initial call to set initial values for this section
    handleSelectCombination();
  });
};

// Run initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLotteryWebforms);
} else {
  initializeLotteryWebforms();
}
